import { forwardRef, type Ref, type SVGProps } from "react";
const IconHOAFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27 9c-1.38 0-3 .92-3 3.5v2.1l1.41 1.21a2.86 2.86 0 0 1 .33 4.19l-3 3.56a1 1 0 1 1-1.54-1.28l2.42-3.08a1.8 1.8 0 0 0-.16-2.34 1.78 1.78 0 0 0-2.65.14l-3.11 3.8a3 3 0 0 0-.7 1.92V29a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1.74L29.18 22a3.7 3.7 0 0 0 .82-2.3v-7.2c0-2.42-1.51-3.5-3-3.5" />
    <path d="M5 9c1.38 0 3 .92 3 3.5v2.1l-1.41 1.21A2.86 2.86 0 0 0 6.26 20l3 3.56a1 1 0 0 0 1.54-1.28l-2.45-3.04a1.8 1.8 0 0 1 .16-2.34 1.78 1.78 0 0 1 2.65.14l3.14 3.76a3 3 0 0 1 .7 1.92V29a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1.74L2.82 22A3.7 3.7 0 0 1 2 19.7v-7.2C2 10.08 3.51 9 5 9" />
    <path d="m21.65 6.47-5-4.23a1 1 0 0 0-1.3 0l-5 4.23a1 1 0 0 0-.35.76v6.27a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5V7.23a1 1 0 0 0-.35-.76M17 13h-2v-2a1 1 0 0 1 2 0Z" />
  </svg>
);
const ForwardRef = forwardRef(IconHOAFilledSVG);
ForwardRef.displayName = "IconHOAFilled";
export { ForwardRef as IconHOAFilled };
